import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useTwilioToken(
  locationTenantId?: string,
  locationId?: number,
  onSuccess?: (token: string) => void,
  onError?: (err: Error) => void,
  toNumber?: string
) {
  let url = `/v2/orm/voice/twilio/token`;
  const params = [];

  if (locationTenantId) {
    params.push(`location_tenant_id=${locationTenantId}`);
  }

  if (locationId) {
    params.push(`location_id=${locationId}`);
  }

  if (toNumber) {
    params.push(`to_number=${encodeURIComponent(toNumber)}`);
  }

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  const request = new Request(url);

  return useAuthenticatedRequest<string>(request, {
    queryKey: ['voice-twilio-token', toNumber],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.token;
    },
    onSuccess,
    onError,
    cacheTime: 0,
    refetchInterval: 55 * 60 * 1000, // 5 mins before token expires
  });
}

export default useTwilioToken;
